import API_BASE from './config';

export async function getUsers() {
    try {
        const res = await fetch(`${API_BASE}/users`, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Network error');
        return await res.json();
    } catch (e) {
        console.error('usersApi.getUsers error', e);
        return [];
    }
}

export async function mergeAccounts(parentId, childId) {
    const res = await fetch(`${API_BASE}/users/merge`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ parentId, childId }),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Merge failed');
    }
    return res.json();
}

export default { getUsers, mergeAccounts };
